import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../App.css";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import OtpInput from "react-otp-input";
import * as apicall from "../../components/Apicall";
import { toast } from "react-toastify";

const Login = () => {
  const [step, setStep] = useState(1); // 1=login, 2=forgot, 3=otp, 4=reset password
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
const handleLogin = async (e) => {
  e.preventDefault();
  try {
    let errors = [];
    if (!email) errors.push("email");
    if (!password) errors.push("password");

    if (errors.length > 0) {
      if (errors.length === 2) {
        toast.error("Please enter email and password");
      } else if (!email) {
        toast.error("Please enter email");
      } else if (!password) {
        toast.error("Please enter password");
      }
      return;
    }

    const data = { email, password };
    let res = await apicall.verifyOTP(data);

    if (res?.user_details) {
      localStorage.setItem("user_details", JSON.stringify(res.user_details));
      if (res?.company_details) {
        localStorage.setItem(
          "company_details",
          JSON.stringify(res.company_details)
        );
      }
      if (res?.user_details?.role === 1) {
        navigate("/admindashboard",{ replace: true });
      } else {
        navigate("/dashboard",{ replace: true });
      }
    } else {
      toast.error("Invalid login details");
    }
  } catch (e) {
    toast.error(e.message?.replace("Error:", "") || "Something went wrong");
  }
};

  const handleSendOtp = () => {
    if (!email) {
      toast.error("Please enter email");
      return;
    }
    setStep(3);
  };

  const handleResetPassword = () => {
    if (!password) {
      toast.error("Please enter new password");
      return;
    }
    if (password !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }
    toast.success("Password reset successful");
    setStep(1);
    setPassword("");
    setConfirmPassword("");
  };

  return (
    <div className="login-wrapper">
      <div className="login-card">
        {/* Step 1 - Login */}
      {step === 1 && (
  <form onSubmit={handleLogin}>
    <h4 className="login-title">Log in</h4>
    <p className="login-subtitle">Streamline your procurement process</p>

    {/* Email */}
    <div className="form-group-custom mb-4">
      <label className="form-label-custom">Email address</label>
      <input
        type="email"
        className="form-control-custom"
        placeholder="Email address"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
      />
    </div>

    {/* Password */}
    <div className="form-group-custom mb-4">
      <div className="label-row">
        <label className="form-label-custom">Password</label>
        <span
          className="forgot-link"
          onClick={() => setStep(2)}
          style={{ cursor: "pointer" }}
        >
          Forgot your password?
        </span>
      </div>

      <div className="password-wrapper">
        <input
          type={showPassword ? "text" : "password"}
          className="form-control-custom"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <span
          className="password-toggle"
          onClick={() => setShowPassword(!showPassword)}
        >
          {showPassword ? <FaRegEye /> : <FaRegEyeSlash />}
        </span>
      </div>
    </div>

    {/* Remember Me */}
    <div className="form-group-custom form-check mb-4 mt">
      <input type="checkbox" className="form-check-input" id="rememberMe" />
      <label className="form-check-label small" htmlFor="rememberMe">
        Remember me
      </label>
    </div>

    {error && <p style={{ color: "red", fontSize: "0.85rem" }}>{error}</p>}

    <div className="form-group-custom">
      <button type="submit" className="btn login-btn">
        Sign in
      </button>
    </div>
  </form>
)}


        {/* Step 2 - Forgot password */}
        {step === 2 && (
          <>
            <h4 className="login-title">Reset Password</h4>
            <p className="login-subtitle">
              Enter your registered email address and we'll send you a one-time password
            </p>

            <div className="form-group-custom mb-4">
              <label className="form-label-custom">Email address</label>
              <input
                type="email"
                className="form-control-custom"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div className="form-group-custom">
              <button className="btn login-btn" onClick={handleSendOtp}>
                Send OTP
              </button>
            </div>

            <div className="form-group-custom mt-2">
              <label className="login-subtitle">
                Remember password?{" "}
                <span
                  style={{ color: "#d01c4c", cursor: "pointer" }}
                  onClick={() => setStep(1)}
                >
                  Back to Login
                </span>
              </label>
            </div>
          </>
        )}

        {/* Step 3 - Enter OTP */}
        {step === 3 && (
          <>
            <h4 className="login-title">Reset Password</h4>
            <p className="login-subtitle">
              OTP sent to {email}{" "}
              <span
                style={{ color: "#d01c4c", cursor: "pointer" }}
                onClick={() => setStep(2)}
              >
                Edit
              </span>
            </p>

            <label className="form-label-custom">One-time password</label>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "15px",
              }}
            >
              <OtpInput
                value={otp}
                onChange={setOtp}
                numInputs={4}
                renderSeparator={<span>&nbsp;&nbsp;</span>}
                renderInput={(props) => <input {...props} />}
                inputStyle={{
                  width: "50px",
                  height: "50px",
                  fontSize: "20px",
                  textAlign: "center",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                }}
              />
            </div>

            <p
              style={{
                color: "#d01c4c",
                cursor: "pointer",
                marginBottom: "20px",
                textAlign: "center",
              }}
            >
              Resend OTP
            </p>

            <div className="form-group-custom">
              <button className="btn login-btn" onClick={() => setStep(4)}>
                Verify OTP
              </button>
            </div>

            <div className="form-group-custom mt-2">
              <label className="login-subtitle">
                Remember password?{" "}
                <span
                  style={{ color: "#d01c4c", cursor: "pointer" }}
                  onClick={() => setStep(1)}
                >
                  Back to Login
                </span>
              </label>
            </div>
          </>
        )}

        {/* Step 4 - Reset password */}
        {step === 4 && (
          <>
            <h4 className="login-title">Reset Password</h4>
            <p className="login-subtitle">Create new password</p>

            {/* New password */}
            <div className="form-group-custom mb-4">
              <div className="label-row">
                <label className="form-label-custom">Create New Password</label>
              </div>
              <div className="password-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control-custom"
                  placeholder="New Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <span
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaRegEye /> : <FaRegEyeSlash />}
                </span>
              </div>
            </div>

            {/* Confirm password */}
            <div className="form-group-custom mb-4">
              <div className="label-row">
                <label className="form-label-custom">Confirm Password</label>
              </div>
              <div className="password-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control-custom"
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
                <span
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaRegEye /> : <FaRegEyeSlash />}
                </span>
              </div>
            </div>

            {error && <p style={{ color: "red", fontSize: "0.85rem" }}>{error}</p>}

            <div className="form-group-custom">
              <button className="btn login-btn" onClick={handleResetPassword}>
                Submit
              </button>
            </div>

            <div className="form-group-custom mt-2">
              <label className="login-subtitle">
                Remember password?{" "}
                <span
                  style={{ color: "#d01c4c", cursor: "pointer" }}
                  onClick={() => setStep(1)}
                >
                  Back to Login
                </span>
              </label>
            </div>
          </>
        )}
      </div>

      {/* Footer */}
      <div className="footer-text">
        <span>Powered by</span>
        <span className="brand-text">
          <img src="/images/logo.png" alt="UtilStop" />
        </span>
      </div>
    </div>
  );
};

export default Login;
